<template>
	<div class="table-responsive">
		<table class="table table-bordered col-sm-12 mt-3">
			<thead>
				<tr>
					<th scope="col">Produit</th>
					<th scope="col">Quantité</th>
					<th scope="col">Poids</th>
					<th scope="col">Volume</th>
					<th scope="col">CA</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(o, i) in totalsProductTypes" :key="i">
					<td>{{ i }}</td>
					<td>{{ o.quantity }}</td>
					<td>{{ $numeral(o.weight).format('0,0.00') }} KG</td>
					<td>{{ $numeral(o.volume).format('0,0.00') }}</td>
					<td>{{ $numeral(o.ca).format('0,0.0€') }} €</td>
				</tr>
				<tr>
					<td class="font-weight-bold">TOTAL</td>
					<td>{{ totalQuantity }}</td>
					<td>{{ $numeral(totalWeight).format('0,0.00') }} KG</td>
					<td>{{ $numeral(totalVolume).format('0,0.00') }}</td>
					<td>{{ $numeral(totalCA).format('0,0.0€') }} €</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
	export default {
		name: 'summary-graph-recap-table',
		props: {
			totalsProductTypes: {
				type: Object,
				default: () => {},
			},
		},

		computed: {
			totalQuantity() {
				let total = 0;

				for (let item of Object.values(this.totalsProductTypes)) {
					total += item.quantity;
				}

				return total;
			},

			totalWeight() {
				let total = 0;

				for (let item of Object.values(this.totalsProductTypes)) {
					total += item.weight;
				}

				return total;
			},

			totalVolume() {
				let total = 0;

				for (let item of Object.values(this.totalsProductTypes)) {
					total += item.volume;
				}

				return total;
			},

			totalCA() {
				let total = 0;

				for (let item of Object.values(this.totalsProductTypes)) {
					total += item.ca;
				}

				return total;
			},
		},
	};
</script>
